import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { read, utils } from 'xlsx';
import { UserService } from '../../../modules/auth/services/user.service';
import { CommunService } from '../../../shared/services/commun';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../../modules/auth/services/token-storage.service';
import { MotifreclamationService } from '../../../shared/services/motifreclamation';
import { Motif } from '../../../modules/reclamation/models/motifreclamation';

@Component({
  selector: 'app-add-potif-rec',
  templateUrl: './add-potif-rec.component.html',
  styleUrls: ['./add-potif-rec.component.scss']
})
export class AddPotifRecComponent implements OnInit {
  exceljsondata4=[];
  file: File;
  uploadEvent: any;
  arrayBuffer: string | ArrayBuffer;
  motifform: FormGroup;
  public ammounts2: FormArray;
  currentUser: any;
  motifs=[];
  motifsSub: any;
  loading: boolean;
motifreclamation:Motif
  constructor(private userservice: UserService,private formBuilder: FormBuilder,private commun: CommunService,
    private router: Router,private token:TokenStorageService, private motifservice:MotifreclamationService) {
      this.motifform = this.formBuilder.group({
        initrec:'',
        creerec:'',
        encoursrec:'',
        initprearb:'',
        repprearb:'',
        initarb:'',
        initcomite:'',
        repacquireur:'',
        currentdate:'',
        relancerec:'',
        initrech:'',
        ammounts2: this.formBuilder.array([ this.createammount2() ])
     });

     }
  ngOnInit() {
    this.currentUser = this.token.getUser();
    this.motifsSub = this.motifservice.motifreclamations$.subscribe(
      (motifs) => {
        console.log(motifs)
        this.motifreclamation=motifs[0];
        this.motifs = motifs[0].groupe;
      //  console.log(motifs)
        this.motifform = this.formBuilder.group({ 
          //@ts-ignore  
        currentdate: new Date(motifs[0].currentdate) ,
          //@ts-ignore  
        initrec: motifs[0].initrec,
          //@ts-ignore
        creerec:motifs[0].creerec,
        //@ts-ignore
        encoursrec:motifs[0].encoursrec,
        //@ts-ignore
        initprearb:motifs[0].initprearb,
        //@ts-ignore
        repprearb:motifs[0].repprearb,
        //@ts-ignore
        initarb:motifs[0].initarb,
        //@ts-ignore
        initcomite:motifs[0].initcomite,
        //@ts-ignore
        repacquireur:motifs[0].repacquireur,   
                //@ts-ignore
        relancerec:motifs[0].relancerec,    
                //@ts-ignore
        initrech:motifs[0].initrech,  
          ammounts2: new FormArray(this.motifs.map(item => {
            const group = this.createammount2();
            //@ts-ignore
            group.patchValue({
              groupe:item.groupe,
              famille:item.famille,
              code:item.code,
              motif:item.motif,
              contientfichier:item.contientfichier,
              rechdocpresentation:item.rechdocpresentation,
              collaballoc:item.collaballoc,
              delai:item.delai,
              delai2:item.delai2,
            });
            return group;
          }))
        });
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        
      }
    );
    
      this.motifservice.getmotifreclamationss();
  }
  get ammountControls2() {
    return this.motifform.get('ammounts2')['controls'];
  }
  addammount2(){
    this.ammounts2 = this.motifform.get('ammounts2') as FormArray;
    this.ammounts2.push(this.createammount2());
  }
  removeammount2(i: number) {
    this.ammounts2 = this.motifform.get('ammounts2') as FormArray;
    this.ammounts2.removeAt(i); 
  }
  createammount2(): FormGroup {
    return this.formBuilder.group({
      famille: '',
      groupe: '',
      code: '',
      motif: '',
      document: '',
      rechdocpresentation: '',
      collaballoc: '',
      delai: '',
      delai2: '',
      contientfichier: '',

    });
  }
  resetdatesysteme()
  {
    this.motifform.get('currentdate').reset()
    console.log(this.motifform.get('currentdate').value)
    this.submit()
  }
  submit() {
    this.loading = true;
    const motif = new Motif();
  console.log(this.motifform.value)  
  motif.groupe =[];
  motif.groupe=this.motifform.get('ammounts2').value
  motif.initrec= this.motifform.get('initrec').value
  motif.creerec= this.motifform.get('creerec').value
  motif.encoursrec= this.motifform.get('encoursrec').value
  motif.initprearb= this.motifform.get('initprearb').value
  motif.repprearb= this.motifform.get('repprearb').value
  motif.initarb= this.motifform.get('initarb').value
  motif.initcomite= this.motifform.get('initcomite').value
  motif.repacquireur= this.motifform.get('repacquireur').value
  motif.relancerec= this.motifform.get('relancerec').value
  motif.initrech= this.motifform.get('initrech').value
  motif.currentdate= new Date(this.motifform.get('currentdate').value).getTime()
  console.log(new Date(this.motifform.get('currentdate').value))
  this.motifs.length==0?
  //@ts-ignore
  this.motifservice.createwithoutfile(motif).then(
    (data:any) => {
      this.loading = false;
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'opération réalisée avec succès!',
        showConfirmButton: false,
        timer: 6000 
      }).then(
        ()=>
        {
          window.location.reload()
        }
      );
    },
    (error) => {
      this.loading = false;                
    }
  ) :
  this.motifservice.modifymotifreclamationreqById(this.motifreclamation._id,motif).then(
    (data:any) => {
      this.loading = false;
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'opérations sauvegardées avec succès!',
        showConfirmButton: false,
        timer: 6000 
      }).then(
        ()=>
        {
          window.location.reload()
        }
      );;
    },
    (error) => {
      this.loading = false;                
    }
  ) 
  }
  onFileChange3(event) {
    this.exceljsondata4 = [];
    if (event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.uploadEvent = event;
    }
    
    let fileReader = new FileReader();
    fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        //@ts-ignore
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var j = 0; j != data.length; ++j)
            arr[j] = String.fromCharCode(data[j]);
        var bstr = arr.join("");
        var workbook = read(bstr, {
            type: "binary"
        });
        var first_sheet_name = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[first_sheet_name];
        this.exceljsondata4 = utils.sheet_to_json(worksheet, {
            raw: true,
            defval: "",
        });
        console.log(this.exceljsondata4);
        
        // Create a new FormArray first
        const newAmmountsArray = new FormArray(
            this.exceljsondata4.map(item => {
                const group = this.createammount2();
                group.patchValue({
                    groupe: item.groupe,
                    famille: item.famille,
                    code: item.code,
                    motif: item.libelle,
                    contientfichier: item.document,
                    rechdocpresentation: item.rechdocpresentation,
                    collaballoc: item.collaballoc,
                    delai: item.delai,
                    delai2: item.delai2,
                });
                return group;
            })
        );

        // Then update the existing form group
        this.motifform.setControl('ammounts2', newAmmountsArray);
    };
    fileReader.readAsArrayBuffer(this.file);
}
}
